"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSProxyHelper = void 0;
var main_1 = require("../main");
var mfePropsSetting_1 = require("../mfe/mfePropsSetting");
var providers_1 = require("../providers");
/** PLACEMENTS TYPE */
var CONTENT_PLACEMENT_TYPE = "content";
var MENU_PLACEMENT_TYPE = "menu";
exports.CMSProxyHelper = {
    wrapResponse: function (data) { return ({ content: { data: data } }); },
    replaceComponentsName: function (data, toReplace) {
        return "placements" in data && Array.isArray(data.placements)
            ? __assign(__assign({}, data), { placements: data.placements.map(function (placement) {
                    var componentToBeReplaced = toReplace[placement.component];
                    return componentToBeReplaced
                        ? __assign(__assign({}, placement), { component: componentToBeReplaced }) : placement;
                }) }) : data;
    },
    getContent: function (placement, childrenRemoteDeps, networkConfig, component) {
        if (childrenRemoteDeps === void 0) { childrenRemoteDeps = {}; }
        if (networkConfig === void 0) { networkConfig = {}; }
        if (component === void 0) { component = ""; }
        return __awaiter(void 0, void 0, void 0, function () {
            var type, dataContentId, projectId, projectName, cmsProxyService, getContentId, startTimestamp, _a, _b, data, pageContent, content, siteAreaName, menuName, dataReq, menuContent, toReturn;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        type = placement.type, dataContentId = placement.dataContentId, projectId = placement.projectId, projectName = placement.projectName;
                        cmsProxyService = providers_1.CMSProxyService.getInstance();
                        getContentId = "GC"
                            .concat(new Date().getTime().toString())
                            .concat(Math.round(Math.random() * 90 + 10).toString());
                        startTimestamp = new Date().getTime();
                        console.log("[getContent ".concat(getContentId, "] Getting page content: ").concat(dataContentId, " component: ").concat(component));
                        return [4 /*yield*/, cmsProxyService.getPageContent(dataContentId, projectId, projectName, networkConfig)];
                    case 1:
                        _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, pageContent = __rest(_a, ["data"]);
                        console.log("[getContent ".concat(getContentId, "] Page content received: ").concat(dataContentId, " component: ").concat(component, ", duration: ").concat(startTimestamp - new Date().getTime()));
                        content = __assign(__assign({}, pageContent), { config: main_1.Utils.extractConfigFromContentData(pageContent.id, data) });
                        if (!(type == MENU_PLACEMENT_TYPE)) return [3 /*break*/, 3];
                        siteAreaName = placement.siteAreaName, menuName = placement.menuName;
                        startTimestamp = new Date().getTime();
                        console.log("[getContent ".concat(getContentId, "] Getting menu content: ").concat(menuName, " siteAreaName: ").concat(siteAreaName, " component: ").concat(component));
                        dataReq = MenuNameRequestRowsLimit[menuName];
                        return [4 /*yield*/, cmsProxyService.getContentMenu(dataContentId, projectId, projectName, menuName, siteAreaName, 1, !dataReq || dataReq.listNumber > 40 ? 40 : dataReq.listNumber, networkConfig)];
                    case 2:
                        menuContent = _c.sent();
                        console.log("[getContent ".concat(getContentId, "] Getting menu content: ").concat(menuName, " siteAreaName: ").concat(siteAreaName, " component: ").concat(component, ", duration:  ").concat(startTimestamp - new Date().getTime()));
                        content = __assign(__assign({}, content), { menu: __assign(__assign({}, menuContent), { itemsMenu: (menuContent.itemsMenu || []).map(function (_a) {
                                    var data = _a.data, menuItem = __rest(_a, ["data"]);
                                    return __assign(__assign({}, menuItem), { config: main_1.Utils.extractConfigFromContentData(menuItem.id, data) });
                                }) }) });
                        _c.label = 3;
                    case 3:
                        toReturn = __assign(__assign({}, content), { config: __assign(__assign({}, content.config), dataWidget(childrenRemoteDeps, content.config, content.menu)) });
                        // ELIMINA LE PROPS DEI WIDGET E DEI CORE ANNIDATI DA QUELLE PRESENTI NEL PRIMARY SCESE DAL CMS
                        Object.keys(childrenRemoteDeps).forEach(function (mfeName) {
                            var _a, _b;
                            toReturn.config = deleteKeys(!!mfePropsSetting_1.WIDGETS_FILTERED_CONFIGS[mfeName], mfePropsSetting_1.WIDGETS_FILTERED_CONFIGS[mfeName], toReturn.config);
                            toReturn.config = deleteKeys(!!((_a = mfePropsSetting_1.NESTED_REMOTES_CONFIGS[mfeName]) === null || _a === void 0 ? void 0 : _a.config), (_b = mfePropsSetting_1.NESTED_REMOTES_CONFIGS[mfeName]) === null || _b === void 0 ? void 0 : _b.config, toReturn.config);
                            // CANCELLA MENU SE PRESENTE
                            if (mfeName in mfePropsSetting_1.WIDGETS_FILTERED_CONFIGS) {
                                delete toReturn.menu;
                            }
                        });
                        return [2 /*return*/, toReturn];
                }
            });
        });
    },
};
// CANCELLA TUTTE LE CONFIG PRESENTI NEL WIDGET E PRIMARY FIGLI/NIPOTI DALLA ROOT
function deleteKeys(calledByConst, collection, config) {
    if (calledByConst) {
        collection.forEach(function (keyProp) {
            delete config[keyProp];
        });
    }
    return config;
}
// COSTRUISCE LE CONFIG DEI WIDGET ANGULAR RICHIAMATI DAL PRIMARY RADICE
// IN BASE ALL'ELENCO PRENSENTE NELLA CONST WIDGETS_FILTERED_CONFIGS
// E AGGIUNGE LE PROPS DEL MENU SE PRESENTI
function dataWidget(childrenRemoteDeps, rootConfig, menu) {
    return Object.keys(childrenRemoteDeps)
        .filter(function (mfeName) { return /^widget/i.test(main_1.MFE_SETTINGS[mfeName].type); })
        .reduce(function (acc, mfeName, index) {
        var _a, _b;
        // RETROCOMPATIBILITA'
        var configWidgetFilters = mfePropsSetting_1.WIDGETS_FILTERED_CONFIGS[mfeName];
        var tmpConfig = (configWidgetFilters === null || configWidgetFilters === void 0 ? void 0 : configWidgetFilters.length) > 0
            ? pick(rootConfig, configWidgetFilters)
            : {};
        var widgetData = {
            id: mfeName + "_" + index,
            name: mfeName,
            __mfeName__: mfeName,
            type: main_1.MFE_SETTINGS[mfeName].type,
            config: __assign(__assign({}, tmpConfig), dataNestedRemote(childrenRemoteDeps, rootConfig)),
        };
        return menu
            ? __assign(__assign({}, acc), (_a = {}, _a[mfeName] = __assign(__assign({}, widgetData), { menu: __assign({}, menu) }), _a)) : __assign(__assign({}, acc), (_b = {}, _b[mfeName] = __assign({}, widgetData), _b));
    }, {});
}
// COSTRUISCE LE CONFIG DEL REMOTE ANNIDATO NEL WIDGET ANGULAR IN BASE
// ALL'ELENCO PRENSENTE NELLA CONST NESTED_REMOTES_CONFIGS
function dataNestedRemote(childrenRemoteDeps, rootConfig) {
    return Object.keys(childrenRemoteDeps)
        .filter(function (mfeName) { return /^widget/i.test(main_1.MFE_SETTINGS[mfeName].type); })
        .reduce(function (acc, mfeName, index) {
        var _a;
        var configPrimaryFilters = mfePropsSetting_1.NESTED_REMOTES_CONFIGS[mfeName];
        var tmpConfig = (configPrimaryFilters === null || configPrimaryFilters === void 0 ? void 0 : configPrimaryFilters.config) && (configPrimaryFilters === null || configPrimaryFilters === void 0 ? void 0 : configPrimaryFilters.config.length) > 0
            ? pick(rootConfig, configPrimaryFilters.config)
            : {};
        if (configPrimaryFilters === null || configPrimaryFilters === void 0 ? void 0 : configPrimaryFilters.mfeName) {
            return __assign(__assign({}, acc), (_a = {}, _a[configPrimaryFilters.mfeName] = {
                id: configPrimaryFilters.mfeName + "_" + index,
                name: configPrimaryFilters.mfeName,
                __mfeName__: configPrimaryFilters.mfeName,
                type: main_1.MFE_SETTINGS[configPrimaryFilters.mfeName].type,
                config: tmpConfig,
            }, _a));
        }
        else {
            return __assign({}, acc);
        }
    }, {});
}
// PRENDE LE SOLE CONFIG PASSATE IN keysToExtract
function pick(config, keysToExtract) {
    return keysToExtract.reduce(function (acc, key) {
        if (config[key]) {
            acc[key] = config[key];
        }
        return acc;
    }, {});
}
/** Map of MenuName and the number of row that should be returned */
var MenuNameRequestRowsLimit = {
    /** Temporary setted to Y waiting until the service manages the N rows x req */
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Lancio_Prodotto": {
        pages: 1,
        listNumber: 10,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/Generic/CMS-Proxy_Menu_Listing_Link": {
        pages: 1,
        listNumber: 2,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_FAQ_Accordion": {
        pages: 1,
        listNumber: 10,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Scopri_Vantaggi": {
        pages: 1,
        listNumber: 9,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Visore": {
        pages: 1,
        listNumber: 6,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Azioni_Rapide": {
        pages: 1,
        listNumber: 10, // 5,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Documentazione": {
        pages: 1,
        listNumber: 40,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Servizi": {
        pages: 1,
        listNumber: 4,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/Utile-a-Sapersi/CMS-Proxy_Menu_Lancio_Utile_A_Sapersi": {
        pages: 1,
        listNumber: 40,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/Utile-a-Sapersi/CMS-Proxy_Menu_Lancio_Utile_A_Sapersi_Categoria": {
        pages: 1,
        listNumber: 40,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/Generic/CMS-Proxy_Menu_Listing_Box": {
        pages: 1,
        listNumber: 10,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Highlight": {
        pages: 1,
        listNumber: 4,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Vantaggi": {
        pages: 1,
        listNumber: 6,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/Generic/CMS-Proxy_Menu_Faq": {
        pages: 1,
        listNumber: 40,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_A_Chi_Si_Rivolge_Title": {
        pages: 1,
        listNumber: 7,
    },
    "UnipolSai-Disegno-Area-Riservata/CMS-Proxy/CMS-Proxy_Menu_Header": {
        pages: 1,
        listNumber: 10,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Scheda_Comparativa": {
        pages: 1,
        listNumber: 20,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/Utile-a-Sapersi/CMS-Proxy_Menu_Visore_Apertura": {
        pages: 1,
        listNumber: 4,
    },
    "UnipolSai-Disegno-AssistenzaPAS/CMS-Proxy/CMS-Proxy_menu_numeri_utili": {
        pages: 1,
        listNumber: 5,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Blocchi_CTA": {
        pages: 1,
        listNumber: 6,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Nuovo_Lancio_Preventivatori": {
        pages: 1,
        listNumber: 10, // 7,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Aree_Di_Garanzia": {
        pages: 1,
        listNumber: 10, // 6,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Aree_Di_Garanzia2": {
        pages: 1,
        listNumber: 6,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Garanzie": {
        pages: 1,
        listNumber: 10,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/Sinistri/CMS-Proxy_Menu_Lanci_Sinistri_Small": {
        pages: 1,
        listNumber: 10,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Lancio_Convenzioni": {
        pages: 1,
        listNumber: 40,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Convenzioni_Multiple": {
        pages: 1,
        listNumber: 12,
    },
    "UnipolSai-Disegno-QuotazioniRendiconti/CMS-Proxy/CMS-Proxy_Menu_Lista_Documenti_Short": {
        pages: 1,
        listNumber: 40,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_Lancio_Convenzioni_Empty": {
        pages: 1,
        listNumber: 40,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/CMS-Proxy_Menu_giftCard_SceltaProdotto_Img": {
        pages: 1,
        listNumber: 10,
    },
    "UnipolSai-Disegno-Area-Pubblica/CMS-Proxy/Generic/CMS-Proxy_Menu_Lista_Documenti": {
        pages: 1,
        listNumber: 10,
    },
};
